const EmailIcon = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="22" fill="#EEF2FF" />

      <rect
        x="14"
        y="16"
        width="20"
        height="16"
        rx="3"
        stroke="#0F1560"
        strokeWidth="2"
      />

      <path
        d="M14 18L24 25L34 18"
        stroke="#0F1560"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EmailIcon;
